import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "src/app/shared/services/api.service";
import { IBiobank } from "../interfaces/biobanks.interface";

@Injectable({
  providedIn: "root",
})
export class BiobankService {
  constructor(private api: ApiService) {}

  /**
   * Fetch all available biobanks
   * @return The list of biobanks
   */
  public getBiobanks(): Observable<IBiobank[]> {
    return this.api.get("biobanks") as Observable<IBiobank[]>;
  }
}
